import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Notification from "../../elements/notification/Notification";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import ClientProjectWrapper from "../ClientProjectWrapper";
import { NavLink, useHistory } from "react-router-dom";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";

import { StyledClientDetailsWrapper } from "../styledClients";
import { StyledContentWrapper } from "../../styles/styledMain";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const ClientDetailsContainer = ({ match }) => {
  const { t } = useTranslation("clientsPage");
  const [client, setClient] = useState();

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchClient = () => {
    axios.get("/api/users/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setClient(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchClient();
  }, []);

  if (!client) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledClientDetailsWrapper>
        <Helmet>
          <title>
            {!client.firstname || !client.lastname ? t("details.meta.title") : `${client.firstname} ${client.lastname}`} • eXsoft.io</title>
        </Helmet>
        <StyledContentWrapper height="auto" className="client-details-head">
          <GoToBackButton pt="20" pb="30" handler={() => {history.goBack();}} />
          <div className="client-info">
            <div className="client">
              <div className="client__image">
                {!client.firstname ? "-" : client.firstname.charAt(0)}
              </div>
              <div className="client__name">
                {!client.firstname || !client.lastname ?
                  <span>{t("details.nameIsMissing")}</span> : `${client.firstname} ${client.lastname}`} {!client.nickname ?
                "" : `(${client.nickname})`}
              </div>
            </div>
            <div className="client-info__content">
              <div className="client-info__row client-info__email" title="E-mail">
                <span className="icon-light-mail" />
                <CopyToClipboard
                  text={client.email}
                  onCopy={() => {
                    setNotification({ ...notification, visible: true, type: "success", message: t("details.copied") });
                  }}
                >
                  <p>
                    {client.email}
                  </p>
                </CopyToClipboard>
              </div>
              <div className="client-info__row client-info__registration" title={t("table.createDate")}>
                <span className="icon-light-calendar" />
                <p>
                  {TimestampToDateMoment(client.createDate)}
                </p>
              </div>
            </div>
          </div>
        </StyledContentWrapper>
        <ClientProjectWrapper match={match} />
      </StyledClientDetailsWrapper>
    </>
  );
};

export default ClientDetailsContainer;